import { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { authService } from '../../services/auth';

function formatDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export default function AccountTab() {
  const navigate = useNavigate();
  const { onLogout } = useOutletContext();
  const { theme, setTheme, themes } = useTheme();
  const [user, setUser] = useState(null);

  useEffect(() => {
    authService.fetchUser((res) => setUser(res.data), console.error);
  }, []);

  const logout = () => {
    authService.logout();
    onLogout();
    navigate('/login/');
  };

  return (
    <div className="max-w-lg space-y-8">
      <section>
        <h2 className="text-sm font-medium opacity-60 uppercase tracking-wider mb-4">Profile</h2>
        <div className="rounded-2xl border border-theme-secondary bg-theme-main p-5 space-y-4">
          <div>
            <div className="text-xs opacity-50 mb-1">Email</div>
            <div className="font-medium">{user?.email || '—'}</div>
          </div>
          {user?.organization && (
            <div>
              <div className="text-xs opacity-50 mb-1">Organization</div>
              <div className="font-medium">{user.organization.name}</div>
            </div>
          )}
          <div>
            <div className="text-xs opacity-50 mb-1">Member since</div>
            <div className="font-medium">{formatDate(user?.date_joined)}</div>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-sm font-medium opacity-60 uppercase tracking-wider mb-4">Appearance</h2>
        <div className="flex gap-2 flex-wrap">
          {themes.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setTheme(t)}
              className={`px-4 py-2 rounded-xl text-sm capitalize transition-all ${
                theme === t
                  ? 'bg-theme-primary text-theme-button shadow-sm'
                  : 'border border-theme-secondary hover:border-theme-primary/40'
              }`}
            >
              {t}
            </button>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-sm font-medium opacity-60 uppercase tracking-wider mb-4">Session</h2>
        <button
          type="button"
          onClick={logout}
          className="px-4 py-2 rounded-lg border border-theme-secondary text-sm opacity-80 hover:opacity-100 hover:border-red-400/50 hover:text-red-400 transition-colors"
        >
          Log out
        </button>
      </section>
    </div>
  );
}
